import Vue from 'vue'
import service from '../services/bankAccountsService'

export function useReportTransactions() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false,
    report: {},
    account: {},
    next:null,
    previous:null,
  })

  async function getReportTransactions(params = {}) {
    state.loading = true
    try {
      const response = await service.getReportTransactions(params)
      state.items = response.transactions.current_page === 1
        ? [...response.transactions.data]
        : [...state.items, ...response.transactions.data]
      state.report = response.report
      state.account = response.account
      state.previous = response.buttons.previous
      state.next = response.buttons.next
      state.currentPage = response.transactions.current_page
      state.lastPage = response.transactions.last_page
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getExpenses(payload) {
    state.loading = true
    try {
      const response = await service.getExpenses(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getTransaction(payload) {
    state.loading = true
    try {
      const response = await service.getTransaction(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }


  async function linkExpenses(payload) {
    state.loading = true
    try {
      const response = await service.linkExpenses(payload)
      const idx = state.items.findIndex(
        (el) => el.id === payload.transactionId
      )
      if (idx !== -1) {
        state.items[idx].status = response.item
      }
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function getLinkTypes(payload) {
    state.loading = true
    try {
      const response = await service.getLinkTypes(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }
  
  async function getTransactionDetails(payload) {
    state.loading = true
    try {
      const response = await service.getTransactionDetails(payload)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getReportTransactions, getTransaction, getExpenses, linkExpenses, getLinkTypes, getTransactionDetails }
}
